"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = require("styled-components");
var Md3DRotation_1 = require("@react-icons/all-files/md/Md3DRotation");
var utils_1 = require("../../utils");
function Copy(_a) {
    var value = _a.value;
    if (!value)
        return null;
    return ((0, jsx_runtime_1.jsx)(StyledCopy, __assign({ onClick: function () { return (0, utils_1.copy)(value); } }, { children: (0, jsx_runtime_1.jsx)(Md3DRotation_1.Md3DRotation, {}) })));
}
exports.default = Copy;
var StyledCopy = (0, styled_components_1.styled)("button")({});
